import { Link } from "react-router-dom";

const getLink = (text) => {
    // Controlla se text è null o undefined
    if (!text) {
        return ""; // o ritorna qualsiasi valore predefinito appropriato
    }
    
    // Regex per catturare link con label nel formato [label](url)
    const labeledLinkRegex = /\[([^\]]+)\]\((https?:\/\/[^\s\)]+|www\.[^\s\)]+)\)/g;
    
    // Regex originale per catturare http, https o www (senza label)
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
    
    let processedText = text;
    const labeledLinks = [];
    let match;
    
    // Prima, estrai tutti i link con label e sostituiscili con placeholder temporanei
    while ((match = labeledLinkRegex.exec(text)) !== null) {
        const [fullMatch, label, url] = match;
        const placeholder = `__LABELED_LINK_${labeledLinks.length}__`;
        labeledLinks.push({ label, url, fullMatch });
        processedText = processedText.replace(fullMatch, placeholder);
    }
    
    // Processa il testo risultante per placeholder e URL normali
    const result = [];
    let currentIndex = 0;
    
    // Trova tutti i placeholder e URL nel testo processato
    const placeholderMatches = [...processedText.matchAll(/__LABELED_LINK_(\d+)__/g)];
    const urlMatches = [...processedText.matchAll(urlRegex)];
    
    // Combina e ordina tutti i match per posizione
    const allMatches = [
        ...placeholderMatches.map(m => ({ type: 'placeholder', match: m, index: m.index })),
        ...urlMatches.map(m => ({ type: 'url', match: m, index: m.index }))
    ].sort((a, b) => a.index - b.index);
    
    allMatches.forEach((item, idx) => {
        // Aggiungi il testo prima del match
        if (item.index > currentIndex) {
            const textBefore = processedText.slice(currentIndex, item.index);
            if (textBefore) {
                result.push(textBefore);
            }
        }
        
        if (item.type === 'placeholder') {
            // È un placeholder per un link con label
            const linkIndex = parseInt(item.match[1]);
            const { label, url } = labeledLinks[linkIndex];
            const href = url.startsWith("www") ? `https://${url}` : url;
            result.push(
                <span className="underline" key={`labeled-${idx}`}>
                    <Link to={href}>{label}</Link>
                </span>
            );
        } else if (item.type === 'url') {
            // È un URL normale (senza label)
            const urlText = item.match[0];
            const href = urlText.startsWith("www") ? `https://${urlText}` : urlText;
            result.push(
                <span className="underline" key={`url-${idx}`}>
                    <Link to={href}>{urlText}</Link>
                </span>
            );
        }
        
        currentIndex = item.index + item.match[0].length;
    });
    
    // Aggiungi l'eventuale testo rimanente alla fine
    if (currentIndex < processedText.length) {
        const remainingText = processedText.slice(currentIndex);
        if (remainingText) {
            result.push(remainingText);
        }
    }
    
    return result;
};

export default getLink;